var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { SelectionColumn, SELECTION_CELL_ID } from '../columns';
export var useSelectionCell = function (isSelectable, selectionMode, isRowDisabled) { return function (hooks) {
    if (!isSelectable) {
        return;
    }
    hooks.allColumns.push(function (columns) {
        return selectionMode === 'single' ||
            columns.find(function (c) { return c.id === SELECTION_CELL_ID; })
            ? columns
            : __spreadArray([SelectionColumn({ isDisabled: isRowDisabled })], columns, true);
    });
}; };
